import Main from '@/views/administracion/infraestructura/configuracion/Main.vue';
import MainTiposInfraestructura from '@/views/administracion/infraestructura/configuracion/tiposinfraestructura/Main.vue';
import MainSubtiposInfraestructura from '@/views/administracion/infraestructura/configuracion/subtiposinfraestructura/Main.vue';
import MainCaracterisitcasSubtiposInfraestructura from '@/views/administracion/infraestructura/configuracion/caracteristicassubtiposinfraestructuras/Main.vue';

const auth = ['Planeación:ver'];
const scopes = ['Planeación:crear', 'Planeación:editar', 'Planeación:eliminar'];

const configuracion = [
  {
    path: 'configuracion',
    meta: {
      title: 'Configuración',
      auth,
    },
    component: Main,
    children: [
      {
        name: 'infraestructuraConfiguracionTiposInfraestructura',
        path: 'tiposinfreaestructura',
        meta: {
          title: 'Tipos Infraestructura',
          auth,
          scopes,
        },
        component: MainTiposInfraestructura,
        children: [],
      },
      {
        name: 'infraestructuraConfiguracionSubtiposInfraestructura',
        path: 'subtiposinfreaestructura',
        meta: {
          title: 'Subtipos Infraestructura',
          auth,
          scopes,
        },
        component: MainSubtiposInfraestructura,
        children: [],
      },
      {
        name: 'infraestructuraConfiguracionCaracteristicasSubtiposInfraestructura',
        path: 'caracteristicassubtiposinfreaestructura',
        meta: {
          title: 'Carateristicas Subtipos Infraestructura',
          auth,
          scopes,
        },
        component: MainCaracterisitcasSubtiposInfraestructura,
        children: [],
      },
    ],
  },
];

export default configuracion;
